import { RestaurantOutlined } from "@mui/icons-material";
import {
  Avatar,
  Badge,
  Box,
  Button,
  ClickAwayListener,
  Fade,
  Grid,
  Paper,
  Popper,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { searchStoreActions, selectFilter } from "../saga/searchStoreSlice";
import LabelCheckbox from "./LabelCheckbox";
import {
  homepageActions,
  selectGenres,
} from "features/homepage/saga/homepageSlice";
import { ISearchFilter } from "../models";
import dayjs from "dayjs";

function GenrePickerButton({
  onChange,
}: {
  onChange: (value: string[]) => void;
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
  const genreRef = useRef<HTMLDivElement | null>(null);

  const filter = useAppSelector(selectFilter);
  const dispatch = useAppDispatch();
  const genreList = useAppSelector(selectGenres);

  const [selectedGenres, setSelectedGenres] = useState<string[]>([]);
  const [genresStr, setGenresStr] = useState<string[]>([]);

  const handleClick = (event: any) => {
    setAnchorEl(anchorEl ? null : genreRef.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectGenre = (value: any, label: any) => {
    let newGenreList = [];
    let newGenreListStr = [];
    if (!selectedGenres.includes(value)) {
      newGenreList = [...selectedGenres, value];
      newGenreListStr = [...genresStr, label];
    } else {
      newGenreList = selectedGenres.filter((id) => id !== value);
      newGenreListStr = genresStr.filter((id) => id !== label);
    }
    setSelectedGenres(newGenreList);
    setGenresStr(newGenreListStr);
    onChange(newGenreList);
  };

  const handleSearchGenre = () => {
    const newFilter: ISearchFilter = {
      ...filter,
      genres: selectedGenres,
    };
    setAnchorEl(null);
    dispatch(searchStoreActions.setSearchFilter(newFilter));
  };

  const handleClearGenre = () => {
    const newFilter: ISearchFilter = {
      ...filter,
      genres: [],
    };
    setSelectedGenres([]);
    setGenresStr([]);
    dispatch(searchStoreActions.setSearchFilter(newFilter));
  };

  // const calculateTopPosition = () => {
  //   if (anchorEl) {
  //     const { top } = anchorEl.getBoundingClientRect();
  //     return top;
  //   }
  //   return 0;
  // };
  useEffect(() => {
    setSelectedGenres(filter.genres);
  }, [filter.genres]);

  const open = Boolean(anchorEl);

  return (
    <>
      <Paper
        ref={genreRef}
        sx={{
          display: "flex",
          alignItems: "center",
          p: 1,
          my: 1,
          cursor: "pointer",
        }}
        onClick={handleClick}
      >
        <RestaurantOutlined color="primary" fontSize="small" sx={{ px: 1 }} />
        <Box display="flex" flex={1}>
          {selectedGenres.length === 0 ? (
            <Typography>指定なし</Typography>
          ) : selectedGenres.length === 1 ? (
            <Typography>{genresStr[0]}</Typography>
          ) : (
            <>
              <Typography sx={{ display: "flex", flex: 1 }}>
                料理ジャンル
              </Typography>
              <Avatar
                sx={{
                  bgcolor: "primary.main",
                  fontSize: "small",
                  height: "20px",
                  width: "20px",
                }}
              >
                {selectedGenres.length}
              </Avatar>
            </>
          )}
        </Box>
      </Paper>

      <Popper
        open={open}
        anchorEl={anchorEl}
        placement="right-start"
        transition
        disablePortal
        modifiers={[
          {
            name: "preventOverflow",
            enabled: true,
            options: {
              altAxis: true,
              altBoundary: true,
              tether: true,
              rootBoundary: "document",
              padding: 8,
            },
          },
          {
            name: "offset",
            enabled: true,
            options: {
              offset: [-20, 20],
            },
          },
        ]}
        sx={{
          position: "relative",
          left: "20px",
          overflowX: "unset",
          overflowY: "unset",
          boxShadow: 2,
          zIndex: 5,
          "&::before": {
            boxShadow: "-8px 0px 6px -4px rgba(0, 0, 0, 0.1)",
            backgroundColor: "white",
            content: '""',
            display: "block",
            position: "absolute",
            width: 20,
            height: 20,
            top: "40px",
            transform: "translateY(-50%) rotate(45deg)",
            left: "-10px",
          },
        }}
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClose}>
            <Fade {...TransitionProps} timeout={250}>
              <Box
                bgcolor="white"
                zIndex={120}
                width="600px"
                borderRadius={2}
                p={1}
              >
                <Grid
                  container
                  zIndex={120}
                  p={1}
                  maxHeight="500px"
                  overflow="auto"
                  sx={{
                    scrollbarWidth: "thin",
                  }}
                >
                  {genreList.map((e, index) => (
                    <LabelCheckbox
                      xs={4}
                      value={e.Id}
                      boxLabel={e.Name}
                      px={2}
                      onSelected={handleSelectGenre}
                      defaultState={selectedGenres.includes(e.Id)}
                    />
                  ))}
                </Grid>
                <Box
                  display="flex"
                  justifyContent="end"
                  p={2}
                  borderColor="divider"
                >
                  <Button
                    variant="outlined"
                    onClick={handleClearGenre}
                    sx={{ mx: 2 }}
                  >
                    リセット
                  </Button>

                  <Button variant="contained" onClick={handleSearchGenre}>
                    この条件で検索する
                  </Button>
                </Box>
              </Box>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </>
  );
}

export default GenrePickerButton;
